import { api } from '@upryzze/services';

export const getVisibilityScore = () => api.get('/v2/uavs/visibility-score');

export const getVisibilityScoreHistory = (params = {}) =>
  api.get('/v2/uavs/visibility-score/history', { params });

export const getSiteHealthResults = () => api.get('/v2/uavs/site-health');

export const getUavsInsights = () => api.get('/v2/uavs/insights');

export const getScoreEvents = (params = {}) =>
  api.get('/v2/uavs/events', { params });

// Gap -> AI fix -> apply loop. History is open to all tiers (empty on lower
// tiers); generate + apply are entitlement-gated server-side (403 otherwise).
export const getUavsFixes = (params = {}) =>
  api.get('/v2/uavs/fixes', { params });

export const generateUavsFix = (checkKey) =>
  api.post('/v2/uavs/fixes/generate', { checkKey });

export const applyUavsFix = (applicationId, commitSha) =>
  api.post('/v2/uavs/fixes/apply', { applicationId, commitSha });
